import React, { FC } from 'react';
import { Card, CardBody } from 'reactstrap';
import { ProductModel } from '../../../../shared/orders';
import { LinkButton } from '../../../components';
import { useTranslation } from '../../../translations';
import { displayName } from '../../../utils';
import { ProductInfoBadges } from './utils';

interface ProductItemProps {
  readonly product: ProductModel;
}

export const ProductItem: FC<ProductItemProps> = ({ product }) => {
  const { ts } = useTranslation();
  return (
    <Card className="mb-10">
      <CardBody>
        <h4 style={{ marginRight: '30px' }}>
          {displayName(product)} <small>(ID: {product.id})</small>
        </h4>
        <div className="float-end">
          <LinkButton
            color={product.deletedAt ? 'secondary' : 'primary'}
            outline
            to={`/housekeeping/products/${product.id}`}
          >
            {ts('view_edit_details')}
          </LinkButton>
        </div>
        <div className="mb-10">
          <ProductInfoBadges product={product} />
        </div>
        <div>{product.description ?? <i>{ts('common.no_description_provided')}</i>}</div>
      </CardBody>
    </Card>
  );
};
